import { render } from "./SPFolderLine.vue?vue&type=template&id=22ab051f"
import script from "./SPFolderLine.vue?vue&type=script&lang=js"
export * from "./SPFolderLine.vue?vue&type=script&lang=js"
script.render = render

export default script